var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-stack"},_vm._l((_vm.avatars),function(a,i){return _c('div',{key:i,staticClass:"avatar",style:(`z-index: ${i}`)},[_c('img',{attrs:{"src":a}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }